// import { useState } from 'react';

// interface Props {
//     images: File[];
//     setImages: React.Dispatch<React.SetStateAction<File[]>>;
// }

// const ImageUpload: React.FC<Props> = ({ images, setImages }) => {
//     const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
//         if (e.target.files?.[0]) {
//             const newImages = [...images];
//             newImages[index] = e.target.files[0];
//             setImages(newImages);
//         }
//     };

//     return (
//         <div>
//             <label className="block font-bold mb-2">Изображения (максимум 5)</label>
//             <div className="grid grid-cols-5 gap-4">
//                 {Array.from({ length: 5 }).map((_, index) => (
//                     <div key={index} className="border border-dashed border-gray-300 p-4 relative">
//                         <input
//                             type="file"
//                             accept="image/*"
//                             className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
//                             onChange={(e) => handleFileChange(e, index)}
//                         />
//                         {images[index] ? (
//                             <img
//                                 src={URL.createObjectURL(images[index])}
//                                 alt={`Image ${index + 1}`}
//                                 className="object-cover w-full h-full"
//                             />
//                         ) : (
//                             <span className="text-gray-500">Кликните, чтобы добавить</span>
//                         )}
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default ImageUpload;


// src/components/product/ImageUpload.tsx
// src/components/product/ImageUpload.tsx
import React from "react";

export type ImageType = File | string;

interface Props {
  images: ImageType[];
  setImages: React.Dispatch<React.SetStateAction<ImageType[]>>;
  coverIndex: number;
  setCoverIndex: React.Dispatch<React.SetStateAction<number>>;
}

const ImageUpload: React.FC<Props> = ({ images, setImages, coverIndex, setCoverIndex }) => {
  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    if (e.target.files?.[0]) {
      const newImages = [...images];
      newImages[index] = e.target.files[0];
      setImages(newImages);
    }
  };

  const handleSetCover = (index: number) => {
    setCoverIndex(index);
  };

  const handleRemoveImage = (index: number) => {
    const newImages = [...images];
    newImages.splice(index, 1);
    setImages(newImages);
    if (coverIndex === index) {
      setCoverIndex(0);
    } else if (coverIndex > index) {
      setCoverIndex(coverIndex - 1);
    }
  };

  return (
    <div>
      <label className="block font-bold mt-8 mb-2">Изображения</label>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
        {Array.from({ length: 5 }).map((_, index) => (
          <div key={index} className="border border-dashed border-gray-300 p-4 relative">
            <input
              type="file"
              name={`file_${index}`}
              accept="image/*"
              className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
              onChange={(e) => handleFileChange(e, index)}
            />
            {images[index] ? (
              <>
                {typeof images[index] === "string" ? (
                  <img
                    src={images[index] as string}
                    alt={`Image ${index + 1}`}
                    className="object-cover w-full h-full"
                  />
                ) : (
                  <img
                    src={URL.createObjectURL(images[index] as File)}
                    alt={`Image ${index + 1}`}
                    className="object-cover w-full h-full"
                  />
                )}
                <button
                  type="button"
                  onClick={() => handleSetCover(index)}
                  className={`absolute text-sm bottom-2 left-2 px-2 py-1 rounded text-white ${
                    coverIndex === index ? "bg-green-500" : "bg-gray-500"
                  }`}
                >
                  {coverIndex === index ? "Обложка" : "Сделать обложкой"}
                </button>
                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveImage(index);
                  }}
                  className="absolute top-2 right-2 bg-white rounded-full p-1 text-gray-700"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 
                         8.586l4.293-4.293a1 1 0 011.414 1.414L11.414 
                         10l4.293 4.293a1 1 0 01-1.414 1.414L10 
                         11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 
                         10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </>
            ) : (
              <span className="text-gray-500">Кликните, чтобы добавить</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageUpload;
